@if (isLoading) {
  <div class="loader-overlay">
    <div class="spinner"></div>
  </div>
}

<div class="graph-results" #dialogContent>
  <button class="close-btn" mat-dialog-close aria-label="Close dialog">
    <mat-icon class="close-icon">close</mat-icon>
  </button>

  <div class="dialog-scroll-content" mat-dialog-content>
    <div #detailsContent class="details-section">
      <h2 #dialogHeader tabindex="-1">Graph Results</h2>
    </div>

    <div class="side-by-side">
      <div class="table-container" #tableContent>
        <div class="info" #info>
          <p><strong>Account:</strong> {{ account }}</p>
          <p><strong>Patient:</strong> {{ patient }}</p>
          <p><strong>Test:</strong> {{ testName }}</p>
          <p><strong>Parameter:</strong> {{ parameter }}</p>
        </div>
        <div class="table-scroll-wrapper">
          <table class="styled-table">
            <thead>
              <tr>
                <th class="left-align">Collection Date</th>
                <th class="left-align">Result Value</th>
              </tr>
            </thead>
            <tbody>
              @for (result of results; track result) {
                <tr>
                  <td class="left-align">{{ result.collectionDate | date:'MM/dd/yyyy' }}</td>
                  <td class="left-align">{{ result.resultValueWithUnit }}</td>
                </tr>
              }
            </tbody>  
          </table>
        </div>
      </div>

      <div class="graph-container" #graphContent>
        <canvas baseChart
          [datasets]="lineChartData"
          [options]="lineChartOptions"
          [type]="lineChartType"
          [legend]="lineChartLegend"
          [plugins]="[trendLinePlugin, axisLabelPlugin]"
          >
        </canvas>
        <p class="disclaimer">
          Disclaimer: {{ disclaimerText }}
        </p>
      </div>
    </div>

    <div class="options">
      <mat-checkbox
        id="trendlineCheckbox"
        class="trendline-checkbox"
        type="checkbox"
        [(ngModel)]="showTrendline"
        (change)="toggleTrendline()"
        aria-labelledby="trendlineLabel"
      >
      </mat-checkbox>
      <label id="trendlineLabel" for="trendlineCheckbox" class="trendline-checkbox">Show trendline</label>
    </div>
  </div>

  <div mat-dialog-actions>
    <button mat-stroked-button color="primary" class="download-btn" (click)="downloadAsPDF()">Download as PDF</button>
  </div>
</div>
